export default __webpack_public_path__ + "static/media/right_arrow.03226900.png";